import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import WebFont from 'webfontloader';
import Cropper from './components/Cropper';
import Submitter from './components/Submitter';
import { withData } from './utility/DataContext';


const styles = theme => ({
  loading: {
    width: '100%',
    paddingTop: theme.spacing.unit * 4,
  }
});


class PageUploader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      src: null,
      fontLoaded: false,
      mode: 'crop',
    };
  }

  componentDidMount() {
    const file = this.props.data.file;
    if (!file) {
      this.props.history.push('/');
      return;
    }
    var src = window.URL.createObjectURL(file);
    this.props.data.set('src', src);
    
    this.setState(prevState => {
      if (prevState.src){
        window.URL.revokeObjectURL(prevState.src);
      }
      return {src: src}
    })
    
    WebFont.load({
      custom: {
        families: ['noto'],
      },
      active: () => {try{this.setState({fontLoaded: true})}catch(err){}},
      timeout: 15000
    });
  }

  componentWillUnmount() {
    window.URL.revokeObjectURL(this.state.src);
  }

  changeMode = mode => {
    this.setState({
      mode: mode,
      isInitial: false
    });

  }

  render() {
    // const {classes} = this.props;
    return (
      <div style={{width: '100%', display: 'flex', justifyContent: 'center',}}>
        {this.state.src && this.state.mode === 'crop' &&
          <Cropper src={this.state.src} fontLoaded={this.state.fontLoaded} filename={this.props.data.file.name || ''} changeMode={this.changeMode} />
        }
        {this.state.mode === 'submit' &&
          <Submitter changeMode={this.changeMode} />
        }
      </div>
    );
  }
}

export default withData(withStyles(styles)(PageUploader));


// WEBPACK FOOTER //
// ./src/PageUploader.js